export default __webpack_public_path__ + "static/media/placeHolderCloud.6c9276ab.jpg";